import { Injectable } from '@angular/core';

import { Warehouse } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class WarehouseService extends TmsWebBaseEditService<Warehouse, Warehouse> {
  constructor() {
    super('Warehouse', $localize`Warehouse`);
  }
}
